









import { defineComponent, ref } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'ProductCardDisclaimer',
  setup() {
    const toggleDisclaimerText = ref(true);

    const handleDisclaimerClick = () => {
      toggleDisclaimerText.value = !toggleDisclaimerText.value;
    };

    return {
      toggleDisclaimerText,
      handleDisclaimerClick,
    };
  },
});
